import LicensesPage from './LicensesPage.component'

export default LicensesPage
